import axios from 'axios';

const api = axios.create({
  baseURL: 'https://finetacapi.digipexel.com/api',
  headers: {
    "X-API-KEY": 'Qr17OjTfsd67nP',
    "X-APP-ID": localStorage.getItem("app_id") || '0',
  },
});

const loginAdmin = async (username, password) => {
  const res = await api.post("/login", {
    username,
    password,
  });
  return res.data;
};

const getdashboard = async () => {
  const res = await api.post("/get_dashboard_data");
  return res.data;
};

const getstock = async (query) => {
  const res = await api.post("/get_stock" ,{
    query,
  });
  return res.data;
};

const removeStock = async (query) => {
  const res = await api.post("/removeStock" ,{
    query,
  });
  return res.data;
};

const addStock = async (query) => {
  const res = await api.post("/addStock" ,{
    query,
  });
  return res.data;
};



export {
  loginAdmin,
  getdashboard,
  getstock,
  removeStock,
  addStock,
};